import { render, staticRenderFns } from "./PublicationCardLinkedin.vue?vue&type=template&id=3dce3f06&scoped=true&"
import script from "./PublicationCardLinkedin.vue?vue&type=script&lang=js&"
export * from "./PublicationCardLinkedin.vue?vue&type=script&lang=js&"
import style0 from "./PublicationCardLinkedin.vue?vue&type=style&index=0&id=3dce3f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce3f06",
  null
  
)

export default component.exports